export default class FileInteractionEvent {
    constructor(type, file) {
        this.type = type;
        this.file = file;
    }
}

FileInteractionEvent.OPEN_FILE = 'FileInteractionEvent.OPEN_FILE';
FileInteractionEvent.CLOSE_FILE = 'FileInteractionEvent.CLOSE_FILE';